export var getCountriesQuery = function getCountriesQuery() {
  return "\nquery {\n  countries {\n    value\n    name\n    phoneCode\n  }\n}";
};